"use strict";
/* globals module */
/**
 * @module userWorkRoute
 * @description Baasic User Work Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Work Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var UserWorkRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserWorkRoute, _super);
    function UserWorkRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/work/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/work/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/work';
        _this.updateRoute = 'profiles/{userId}/work/{id}';
        _this.deleteRoute = 'profiles/{userId}/work/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user work properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user work subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user work property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userWorkRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserWorkRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User work id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userWorkRoute.get(id, options);
     **/
    UserWorkRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user work object that needs to be inserted into the system.
     * @example userWorkRoute.create(data);
     **/
    UserWorkRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @param data An user work object used to update specified user work resource.
      * @example userWorkRoute.create(data);
      **/
    UserWorkRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    UserWorkRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserWorkRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserWorkRoute);
    return UserWorkRoute;
}(common_1.BaseRoute));
exports.UserWorkRoute = UserWorkRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
